import React from 'react';


export default function ConfirmForm({ className }) {
  return (
  <svg className={className} width="400" height="400" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.5">
<circle cx="137.5" cy="332.5" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="112.5" cy="307.5" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="87.5" cy="282.5" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="62.5" cy="257.5" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="37.5" cy="232.5" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="12.5" cy="207.5" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="162.5" cy="307.5" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="187.5" cy="282.5" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="212.5" cy="257.5" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="237.5" cy="232.5" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="262.5" cy="207.5" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="287.5" cy="182.5" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="312.5" cy="157.5" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="337.5" cy="132.5" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="362.5" cy="107.5" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="387.5" cy="82.5" r="7.5" fill="#071013" fillOpacity="0.5"/>
</g>
</svg>
  )
}
